export const uk = {
    campaign_context_enable_cpc_hold: 'Удерживать среднюю цену клика ниже средней цены клика на поиске',
    campaign_context_limit:
        'Расход удерживать в пределах {oldLimitPercent} {newLimitPercent} от общего расхода кампании',
    campaign_context_price_coef: 'Максимальная цена клика {oldPriceCoef} {newPriceCoef} от назначенной цены на поиске'
};
